import { render } from "./Content.vue?vue&type=template&id=33d84cc6&scoped=true"
import script from "./Content.vue?vue&type=script&lang=js"
export * from "./Content.vue?vue&type=script&lang=js"

import "./Content.vue?vue&type=style&index=0&id=33d84cc6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33d84cc6"

export default script